import nprogress from './plugins/nprogress'
import router from '@/router'
import { useUserInfoStore } from './stores/modules/user'
import { getItem } from './utils/storage'

// 白名单：不需要登录即可访问的页面（官网所有公开页面）
const whiteList = ['/', '/login', '/xiadanxuzhi', '/zaixianxiadan', '/xinwenzixun', '/fuwuzhichi', '/guanyuwomen']

router.beforeEach(async (to, from, next) => {
  // 显示进度条
  nprogress.start()
  // 获取用户信息
  const userStore = useUserInfoStore()
  // 从缓存中获取用户 token 信息
  const token = getItem('token')
  if (token) {
    // token 存在，并且请求登录页面，不允许，跳转到原来的页面，原来不存在就跳转到首页
    if (to.path === '/login') {
      next({ path: from.path ? from.path : '/' })
    } else {
      if (JSON.stringify(userStore.user) == '{}') {
        // 跳转时，用户信息为空，则请求用户信息
        await userStore.getUserInfo()
      }
      next()
    }
  } else {
    // token 不存在，白名单内的地址可以进入，否则直接跳转到登录页面
    if (whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }
})

router.afterEach(() => {
  // 关闭进度条
  nprogress.done()
})
